// mui
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const RootStyles = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.neutral,
}));


export default function OfferCompany3WayNoResponse() {

  return (
    <RootStyles>
      <Typography variant="body2">
        회사의 응답이 없어서 매칭이 종료되었습니다.
      </Typography>
    </RootStyles>
  )
}
